import React, {useState} from 'react';


import {DesktopModal} from "../../ui/Modal/desktop/DesktopModal.tsx";
import {LoginOrSignIn} from "./components/LoginOrSignIn/LoginOrSignIn.tsx";
import {getNormalizedPhone} from "@/utils/formatters";
import {useScreenDetector} from "@/hooks/useScreenDetector.ts";
import {MobileModal} from "../../ui/Modal/mobile/MobileModal.tsx";
import {SignIn} from "./components/SignIn/SignIn.tsx";
import {RestorePassword} from "./components/RestorePassword/LoginOrSignIn.tsx";
import {SignInFinished} from "./components/SignIn/SignInFinished/SignInFinished.tsx";
// import { useMultiStorage } from '../../hooks/useStorage.ts';
import { API_URL } from '../../config.tsx';
import { setCookie } from '@/utils/cookie.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';
import { useAppDispatch } from '@/utils/storage/stores/store.ts';
import { setIsShowLoginAndSignInPopup } from '@/utils/storage/slices/userSlice.ts';

interface Props {
    isOpen: boolean,
    isSignedIn: boolean,
    isHasAccount: boolean | null,
    close: () => void,
}

export const LoginAndSignInPopup: React.FC<Props> = ({isOpen, close, isHasAccount, isSignedIn,}) => {
    const dispatch = useAppDispatch();
    const {isMobile, isDesktop} = useScreenDetector()
    const [hasAccount, setHasAccount] = useState<boolean | null>(isHasAccount)
    const [signedIn, setSignedIn] = useState(isSignedIn);
    const [isFailedAttempt, setIsFailedAttempt] = useState(false);
    const [isSendPassword, setIsSendPassword] = useState(false);
    const [phone, setPhone] = useState<string>('')
    const [userCookie, setUserCookie] = useState<string>('');
    // const setStorage = useMultiStorage({
    //     showLoginAndSignInPopup: ['showLoginAndSignInPopup', false],
    // })[1];
    const contentNode: Element | null = document.querySelector('.content');

    const handleClose = () => {
        close();
        if(hasAccount === false) setHasAccount(null);
    };

    const handleLogin = (userCookie: string) => {
        setCookie('user', userCookie);
        setTimeout(function () {
            dispatch(userInfoLoader());
        }, 1000);
    };

    const attemptLogin = (phone: string, password: string, changeUserCookie: boolean = false) => {
        if (getNormalizedPhone(phone).length !== 10) {
            window?.alert('Некорректно указан телефон');
            return false;
        }

        setIsFailedAttempt(false);
        fetch(`${API_URL}/attempt_login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({phone, password}),
        })
            .then(response => response.json())
            .then(result => {
                if(result.result === 'failed') {
                    setIsFailedAttempt(true);
                }
                else if(result.userCookie) {
                    if(changeUserCookie) setUserCookie(result.userCookie);
                    handleLogin(result.userCookie);
                    setTimeout(function () {
                        dispatch(setIsShowLoginAndSignInPopup(false));
                        // setStorage('showLoginAndSignInPopup', false);
                    }, 1000);
                }
            })
    }

    const registrationAttemptLogin = (phone: string, password: string) => {
        attemptLogin(phone, password, true)
    }

    const children = <>
        {
            userCookie
            ? <SignInFinished />
            : <>
            {null === hasAccount && (
                <LoginOrSignIn
                    onAuth={setHasAccount}
                    phoneNumber={phone}
                    isFailedAttempt={isFailedAttempt}
                    onPassAndPhoneLogin={attemptLogin}
                    onLoggedOrSignedIn={setSignedIn}
                    isSendPassword={isSendPassword}
                    onPhoneChange={(phoneNumber) => setPhone(getNormalizedPhone(phoneNumber))}
                />
            )}
            {false === hasAccount && (<>
                {
                    !signedIn ?
                        <SignIn
                            onAuth={setHasAccount}
                            phoneNumber={phone}
                            attemptLogin={registrationAttemptLogin}
                            onPhoneChange={(phoneNumber) => setPhone(getNormalizedPhone(phoneNumber))}
                        />
                        : <RestorePassword
                            onAuth={setHasAccount}
                            phoneNumber={phone}
                            setIsSendPassword={setIsSendPassword}
                            onLoggedOrSignedIn={setSignedIn}
                            onPhoneChange={(phoneNumber) => setPhone(getNormalizedPhone(phoneNumber))}
                        />
                    }
                </>)}
            </>
        }
    </>

    return (<>
        {isDesktop && (
            <DesktopModal type='small' isOpen={isOpen} close={handleClose}>
                {children}
            </DesktopModal>
        )}

        {isMobile && contentNode && (<>
            <MobileModal type='window' isOpen={isOpen} close={handleClose}>
                {children}
            </MobileModal>
        </>)}
    </>);
};
